import React from "react";
import { Route } from "react-router-dom";

const RenderRoute = ({ children, ...rest }) => {
  return <Route {...rest} render={(props) => React.cloneElement(children, { render: props })} />;
};

export default RenderRoute;
